import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useVideo } from "../../context/VideoContext";
import { safeGetItem, safeSetItem } from "../../utils/safeStorage";
import { getPortalContainer } from "../../utils/portalContainer";
import "./TutorialGuideModal.css";

const TUTORIAL_STORAGE_KEY = "tutorialGuideDismissedAt";

const TutorialGuideModal = ({ onClose }) => {
  const {
    pauseVideo,
    playVideo,
    setShortcutsEnabled,
    isFullscreen,
    isIOS,
  } = useVideo();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    pauseVideo();
    setShortcutsEnabled(false);
    return () => {
      setShortcutsEnabled(true);
    };
  }, [pauseVideo, setShortcutsEnabled]);

  const handleDismiss = () => {
    if (dontShowAgain) {
      safeSetItem(TUTORIAL_STORAGE_KEY, new Date().toISOString());
    }
    playVideo();
    onClose();
  };

  const portalContainer = getPortalContainer(isIOS, isFullscreen);

  return ReactDOM.createPortal(
    <div className="tgm-overlay">
      <div className="tgm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tgm-header">
          <span className="tgm-icon">🎬</span>
          <h3 className="tgm-title">آشنایی با قابلیت‌های پلیر</h3>
        </div>

        <div className="tgm-body">
          <div className="tgm-feature">
            <div className="tgm-feature-icon">👆</div>
            <div className="tgm-feature-text">
              <strong>ترجمه لغات با لمس</strong>
              <p>روی هر لغت در زیرنویس کلیک کنید تا ترجمه آن را ببینید و ذخیره کنید</p>
            </div>
          </div>

          <div className="tgm-feature">
            <div className="tgm-feature-icon">⏮️</div>
            <div className="tgm-feature-text">
              <strong>زیرنویس قبلی و بعدی</strong>
              <p>با دکمه‌های A و D یا دکمه‌های S‹ و S› زیرنویس قبل و بعد را ببینید</p>
            </div>
          </div>
        </div>

        <div className="tgm-footer">
          <label className="tgm-checkbox">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <span>دیگر این پیام را به من نشان نده</span>
          </label>
          <button className="tgm-btn" onClick={handleDismiss}>
            متوجه شدم
          </button>
        </div>
      </div>
    </div>,
    portalContainer,
  );
};

export default TutorialGuideModal;

export const shouldShowTutorialGuide = () => {
  return !safeGetItem(TUTORIAL_STORAGE_KEY);
};
